import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { defineMessages, useIntl } from 'dibs-react-intl';

import { NftFaq } from 'dibs-nft-faq/exports/NftFaq.tsx';
import { NftFeaturedCreators } from './components/NftFeaturedCreators/NftFeaturedCreators.tsx';
import { NftCreatorTiles } from './components/NftCreatorTiles/NftCreatorTiles.tsx';

import { useDeviceType } from '../nftHeader/hooks/useDeviceType.tsx';

import { type NftCreatorsLayout_viewer$key } from './__generated__/NftCreatorsLayout_viewer.graphql.ts';

import styles from './styles/NftCreatorsLayout.scss';

const messages = defineMessages({
    creatorsHeading: {
        id: 'NftLanding.NftLandingLayout.creatorsHeading',
        defaultMessage: 'All Creators',
    },
});

export type NftCreatorsLayoutViewerKey = NftCreatorsLayout_viewer$key;
export const NftCreatorsLayout: FC<{
    viewer: NftCreatorsLayout_viewer$key | null | undefined;
}> = ({ viewer: viewerProp }) => {
    const { deviceType } = useDeviceType();
    const { formatMessage } = useIntl();
    const viewer = useFragment(
        graphql`
            fragment NftCreatorsLayout_viewer on Viewer {
                ...NftFeaturedCreators_viewer
                ...NftCreatorTiles_viewer @arguments(creatorsItemCount: $creatorsItemCount)
            }
        `,
        viewerProp
    );

    return (
        <>
            <NftFeaturedCreators viewer={viewer} />
            <div className={styles.pageHeading}>
                <h1 className={styles.pageTitle}>{formatMessage(messages.creatorsHeading)}</h1>
            </div>
            <NftCreatorTiles viewer={viewer} isSearch={false} />
            <NftFaq deviceType={deviceType} />
        </>
    );
};
